export default "__VITE_ASSET__9864fe5a__"